<ng-container *ngIf="vendor; else noVendor">
  <span class="package-assigned-pill" [ngClass]="colorClass" [matTooltip]="vendor?.name" (click)="openAddUser()" role="button" tabindex="0">
    <span class="pill-text" title="{{ vendor?.name }}">{{ shortName }}</span>
    <span *ngIf="showCount" class="pill-count">{{ userCount }}</span>
  </span>
</ng-container>

<ng-template #noVendor>
  <span class="package-assigned-pill warn" matTooltip="No vendors">No vendors</span>
</ng-template>
